/**************************************************
 * Nombre:       Home_Certfiicados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import punto from "../../../Recursos/punto.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import uno from '../../../Recursos/uno.png'
import dos from '../../../Recursos/dos.png'

const Home_Certfiicados = () => {
    const {sCell, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 4, md: 4}}>


                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography>
                                <span>
                                   <img src={punto} width={12} height={12} style={{paddingRight: 8}}/>
                                </span>
                                    Certificados y Licencias
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography sx={{fontSize: sCell ? 28 : 32, fontWeight: 700}}>
                                    Respaldo que garantiza nuestra calidad
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={8}
                                sx={{mt: 8}}
                            >

                                {items.map((item, i) => (
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{fontSize: 20, fontWeight: 600}}>{item.nombre}</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography>{item.descripcion}</Typography>
                                        </Grid>


                                    </Grid>
                                ))}


                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-end'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 8, md: 8}}
                            sx={{pl: sCell ? 0 : 24, mt: sCell ? 8 : 0}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <img src={uno} width={ sCell ? '70%' : '60%'} height={'auto'}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: sCell ? -10 : sTab ? 4 : -30}}>
                                <img src={dos} width={ sCell ? '70%' :'60%'} height={'auto'}/>
                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Certfiicados

const items = [
    {
        nombre: 'Licencia de Exportación Vigente',
        descripcion: 'Acreditados por la Federación Nacional de Cafeteros, exportamos café nariñense con respaldo y cumplimiento total.'
    },
    {
        nombre: 'Calidad y Trazabilidad',
        descripcion: 'Garantizamos control en cada etapa, desde el cultivo hasta la taza, asegurando frescura y consistencia.'
    },
    {
        nombre: 'Compromiso con la Excelencia',
        descripcion: 'Cada certificación refleja nuestro respeto por el origen, la sostenibilidad y la calidad del café colombiano.'
    },
]